import { render } from "./Comissoes.vue?vue&type=template&id=ccbdc450&scoped=true"
import script from "./Comissoes.vue?vue&type=script&lang=js"
export * from "./Comissoes.vue?vue&type=script&lang=js"

import "./Comissoes.vue?vue&type=style&index=0&id=ccbdc450&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccbdc450"]])

export default __exports__